import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSetCurrentShopConfigChargeLimitMutation = createMutationHook(
  ShopsApiClient.setCurrentShopConfigChargeLimit,
  {
    mutationKey: ['setCurrentShopConfigChargeLimit'],
  },
)
